export { default, I18nContext, I18nProvider, useI18n } from './i18n'

export type { I18nType } from './i18n'
